var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.screen}},[_c('el-tooltip',{attrs:{"content":_vm.fullscreen?'取消全屏':'全屏',"effect":"dark","placement":"bottom"}},[_c('span',{staticClass:"icon iconfont",staticStyle:{"font-size":"22px"}},[_vm._v("")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65334089","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/screenfull/index.vue
// module id = null
// module chunks = 